import { Utils } from "@singularsystems/neo-core";
var ColumnHelper = /** @class */ (function () {
    function ColumnHelper() {
    }
    ColumnHelper.addCommonClasses = function (className, props) {
        if (props.hideBelow) {
            className = Utils.joinWithSpaces(className, "d-none d-".concat(props.hideBelow, "-table-cell"));
        }
        if (props.hideAbove) {
            className = Utils.joinWithSpaces(className, "d-table-cell d-".concat(props.hideAbove, "-none"));
        }
        if (props.alignment) {
            className = Utils.joinWithSpaces(className, "col-align-".concat(props.alignment));
        }
        return className;
    };
    return ColumnHelper;
}());
export { ColumnHelper };
